export const parseAmountWithRial = (value: number | string) => {
  if (value) {
    return `  ${Number(value).toLocaleString('en-AU').toString()}    ریال    `
  }
  return ''
}

export const parseAmount = (value: number | string) => {
  return Number(value).toLocaleString('en-AU').toString()
  return ''
}
